/**
 * BoM hexagon mark — "Break or Make".
 * A hexagon split down the middle: an orange fracture (break) on the left,
 * a blue rising arrow (make) on the right.
 */
export const LogoMark = ({ size = 28, className = "" }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-hidden="true"
            data-testid="bom-logo-mark"
        >
            <defs>
                <linearGradient id="bomGrad" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#60A5FA" />
                    <stop offset="1" stopColor="#1E3A8A" />
                </linearGradient>
            </defs>
            {/* Hexagon */}
            <path
                d="M32 3 L57 17 L57 47 L32 61 L7 47 L7 17 Z"
                stroke="url(#bomGrad)"
                strokeWidth="2.5"
                strokeLinejoin="round"
            />
            {/* Center divider */}
            <line
                x1="32" y1="12" x2="32" y2="52"
                stroke="url(#bomGrad)"
                strokeWidth="1.5"
                strokeOpacity="0.45"
                strokeDasharray="3 3"
            />
            {/* Break: orange fracture (left) */}
            <path
                d="M24 15 L18 26 L25 31 L17 42 L23 49"
                stroke="#FB923C"
                strokeWidth="2.5"
                strokeLinejoin="round"
                strokeLinecap="round"
                fill="none"
            />
            {/* Make: blue rising arrow (right) */}
            <path
                d="M40 48 L40 24"
                stroke="url(#bomGrad)"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
            <path
                d="M34 30 L40 23 L46 30"
                stroke="url(#bomGrad)"
                strokeWidth="2.5"
                strokeLinejoin="round"
                strokeLinecap="round"
                fill="none"
            />
        </svg>
    );
};

export default LogoMark;
